import Icon from '../components/Icon.vue'

Icon.register({"envelope-open":{"width":512,"height":512,"paths":[{"d":"M512 464C512 490.5 490.5 512 464 512H48C21.5 512 0 490.5 0 464V200.7A48-48 0 0 0 18.4 162.9C43.3 143.4 63.9 127.6 182.6 41.4 199.4 29.2 232.8-0.3 256 0 279.2-0.4 312.6 29.2 329.4 41.4 448.1 127.6 468.7 143.4 493.6 162.9A48-48 0 0 0 512 200.7V464zM446.3 267.4C443.8 263.7 438.6 262.8 435 265.5 412.1 282.4 379.5 306.2 329.4 342.6 312.6 354.8 279.2 384.3 256 384 232.8 384.3 199.4 354.9 182.6 342.6 132.5 306.2 99.9 282.4 77 265.5 73.4 262.8 68.2 263.7 65.7 267.4L56.6 280.6A8-8 0 0 1 58.4 291.6C81.3 308.5 113.9 332.2 163.7 368.4 184 383.2 220.3 416.2 256 416 291.7 416.2 328 383.2 348.3 368.4 398.1 332.2 430.7 308.5 453.6 291.6A8-8 0 0 1 455.4 280.6L446.3 267.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/envelope-open.js
// module id = null
// module chunks = 